'use client';

import { useMemo, useState } from 'react';

export function WordCounter() {
  const [text, setText] = useState('');

  const stats = useMemo(() => {
    const trimmed = text.trim();
    const words = trimmed ? trimmed.split(/\s+/).length : 0;
    const characters = text.length;
    const charactersNoSpaces = text.replace(/\s/g, '').length;
    const sentences = trimmed ? (trimmed.match(/[.!?]+(?=\s|$)/g)?.length ?? (trimmed ? 1 : 0)) : 0;
    const paragraphs = trimmed ? trimmed.split(/\n+/).filter(Boolean).length : 0;
    const readingMinutes = words / 200;
    const speakingMinutes = words / 130;

    return {
      words,
      characters,
      charactersNoSpaces,
      sentences,
      paragraphs,
      readingMinutes,
      speakingMinutes,
    };
  }, [text]);

  return (
    <div className="rounded-2xl border border-border bg-card p-5">
      <textarea
        name="word-counter-text"
        autoComplete="off"
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Paste or type your text here…"
        rows={8}
        className="w-full resize-y rounded-lg border border-input bg-background p-3 text-sm text-foreground outline-none focus:border-ring focus:ring-2 focus:ring-ring/30"
      />

      <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-4">
        <Stat label="Words" value={stats.words} />
        <Stat label="Characters" value={stats.characters} />
        <Stat label="Sentences" value={stats.sentences} />
        <Stat label="Paragraphs" value={stats.paragraphs} />
      </div>

      <p className="mt-3 text-sm text-muted-foreground">
        ~{formatMinutes(stats.readingMinutes)} reading time · ~
        {formatMinutes(stats.speakingMinutes)} speaking time
      </p>
    </div>
  );
}

function formatMinutes(minutes: number) {
  if (minutes < 1) return '<1 min';
  return `${Math.ceil(minutes)} min`;
}

function Stat({ label, value }: { label: string; value: number }) {
  return (
    <div className="rounded-xl bg-muted px-3 py-3 text-center">
      <p className="text-xl font-bold text-foreground">{value.toLocaleString()}</p>
      <p className="text-xs font-medium text-muted-foreground">{label}</p>
    </div>
  );
}
